<template>
  <button class="relative text-size_4" @click="toggleMenu" @blur="closeMenu">
    <div class="flex w-full items-center justify-between">
      <div class="flex gap-spacing_2">
        <UIcons class="h-icon_size_5 w-icon_size_5" name="ic-world" />
        <span
          class="font-secondary text-size_4 font-bold"
          :class="{
            'text-neutral-800': !disabled,
            'text-neutral-500': disabled,
          }"
        >
          {{ $t("common.titles.lang") }}
        </span>
      </div>
      <UIcons class="h-icon_size_1 w-icon_size_1" name="ic-arrow-down" />
    </div>

    <!-- Dropdown menu -->
    <ul
      v-if="showMenu"
      class="absolute top-full z-20 mt-4 flex w-full flex-col gap-spacing_3 rounded-md border border-neutral-400 bg-white p-spacing_7"
    >
      <li
        v-for="lang in langs"
        class="flex w-full items-center justify-between text-center"
        @click="selectLanguage(lang)"
      >
        <span>
          {{ lang.name }}
        </span>
        <UIcons v-if="currentLang.code === lang.code" name="ic-check" />
      </li>
    </ul>
  </button>
</template>

<script setup lang="ts">
import type { LangType } from "~/types/Data/Common/languages";
import UIcons from "~/components/common/UIcons.vue";

const emit = defineEmits<{
  select: [lang: LangType];
}>();

defineProps<{
  currentLang: LangType;
  langs: LangType[];
  disabled?: boolean;
}>();

const showMenu = ref(false);

const toggleMenu = () => {
  showMenu.value = !showMenu.value;
};

const closeMenu = () => {
  showMenu.value = false;
};

const selectLanguage = (lang: LangType) => {
  emit("select", lang);
  closeMenu();
};
</script>
